const escapeRegexpString = (str: string) => {
  if (!str) {
    return null
  }

  return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}

export {
  escapeRegexpString
}



// WEBPACK FOOTER //
// ./src/app/utils/regexp/index.ts